import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../component/ui/Button';
import Table from '../../component/table/Table';
import Pagination from '../../component/pagination';
import addFilter from '../../assets/image/AddFilter.svg';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import advanceFilterIcon from '../../assets/image/advanceFilter_white.svg';
import { toast } from 'react-toastify';
import { ExportTable } from '../../store/action/export/Export';
import './CreatePurchaseBill.scss';
import DeletePurchaseBillModel from './components/DeletePurchaseBillModel';
import {
	deletePurchaseBill,
	fetchPurchaseBill,
	generatePurchaseBillsPdf,
	getPurchaseBills,
} from '../../services/purchase_bill';
import { getDate } from '../../utils/dateUtils';
import pdfMake from 'pdfmake/build/pdfmake';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import AdvanceFilter from '../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../component/Filter/advanceFilterOptions';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import axiosInstance from '../../services/axios';
import { APP_API_URL } from '../../utils/xhr-instance';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../helper';
import { generatePurchaseBillPdf } from './components/generatePurchaseBillPdf';
import PageLoader from '../../component/PageLoader';
import { hasPermission } from '../../utils/controller';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const PurchaseBills = () => {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const [purchaseBill, setPurchaseBills] = useState({
		currentPage: 1,
		totalPages: 0,
		data: [],
	});
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('All Purchase Bills');
	const [sortDirection, setSortDirection] = useState({ purchase_bill_id: 'asc' });
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const [selectedVendorsListForDelete, setSelectedVendorsListForDelete] = useState([]);
	const [purchaseBillParams, setPurchaseBillParams] = useState({
		page: 1,
		pageSize: 20,
		orderBy: 'created_at',
		sortBy: 'desc',
		filters: {},
	});
	const [deselectRows, setDeselectRows] = useState(null);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};
	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);

	const navigateRouter = (path) => {
		navigate(path);
	};
	const onRowClick = (id) => {
		if (id && hasPermission('purchases.purchase_bills.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/purchases-bills-details/${id}`);
		}
	};

	const PurchaseBillColoum = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'bill_date', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DATE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.bill_date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PO#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'purchase_order_number', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PO#
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.purchase_order_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PR#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'purchase_receive_id', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PR#
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.purchase_recieve_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PURCHASE BILL#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'purchase_bill_id', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PURCHASE BILL#
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.purchase_bill_id]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const PB = JSON.parse(params.data['PB']);
				return (
					<p style={{ alignItems: 'center' }}>
						{PB?.pb_number}
						{PB?.status === 0 && (
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								Draft
							</span>
						)}
					</p>
				);
			},
		},

		{
			field: 'VENDOR NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								VENDOR NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.vendor_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 120,
			maxWidth: 120,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const status = params.data?.STATUS || 0;
				if (status) {
					return (
						<p>
							<span
								style={{
									color:
										status === 0
											? '#000'
											: status === 1
												? '#FFC008'
												: status === 2
													? '#FFA500'
													: '#6AA247',
								}}
							>
								{status === 0
									? 'N/A'
									: status === 1
										? 'Open'
										: status === 2
											? 'Partially Paid'
											: 'Closed'}
							</span>
						</p>
					);
				} else {
					return (
						<p>
							<span
								style={{
									color: '#000',
								}}
							>
								N / A
							</span>
						</p>
					);
				}
			},
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ orderBy: 'bill_amount', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '65px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.bill_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'BALANCE DUE',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ orderBy: 'due_amount', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '95px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								BALANCE DUE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.due_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	const FilterDatalist = (param, value, dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Purchase Bill') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Purchase Bill');
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'Draft', value: 'Draft' },
			{ key: 'Open', value: 'Open' },
			{ key: 'Partially Paid', value: 'Partially Paid' },
			{ key: 'Paid/Closed', value: 'Paid/Closed' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setPurchaseBillParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
				filters: {},
			}));
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page: page }));
		} else {
			setPurchaseBillParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	async function handlePBPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				const obj = {};
				obj.pdf = {
					button: type,
					isLoading: true,
				};

				return {
					...prev,
					...obj,
				};
			});
			const pdf_details = await generatePurchaseBillsPdf(bulkAction.join(','), true);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_bills_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	const exportData = (param) => {
		ExportTable(param);
	};

	async function handleBulkDelete() {
		try {
			await deletePurchaseBill(bulkAction);
			toast.success('Purchase Bill Deleted Successfully.');
			setIsDeleteBulkConfirmationModalOpen(false);
			setBulkAction([]);
			handleFetchPurchaseBill();
			deselectRows && deselectRows();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeletePurchaseBillModal() {
		const selectedVendorsList = tableData?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(JSON.parse(item.PB).pb_number);
				return acc;
			}
			return acc;
		}, []);
		setSelectedVendorsListForDelete(selectedVendorsList);
		setIsDeleteBulkConfirmationModalOpen(true);
	}

	async function handleFetchPurchaseBill() {
		try {
			setLoader(true);
			const { purchaseBills, totalPages } = await getPurchaseBills(purchaseBillParams);
			const data = purchaseBills
				? purchaseBills.map((pr) => {
						return {
							id: pr.purchase_bill_id,
							DATE: getDate(pr.bill_date),
							'PO#': pr?.purchase_order_number || 'N/A',
							'PR#': pr?.purchase_receive_number || 'N/A',
							'VENDOR NAME': pr?.vendor_name,
							AMOUNT: Number(pr?.bill_amount).toFixed(2),
							'BALANCE DUE': Number(pr?.due_amount).toFixed(2),
							STATUS: pr?.status,
							PB: JSON.stringify({
								pb_number: pr?.bill_number,
								status: pr?.status,
								AMOUNT: pr?.bill_amount,
							}),
						};
					})
				: [];
			setPurchaseBills((prev) => ({
				...prev,
				data: data,
				totalPages,
			}));
			setTableData(data);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const data = await fetchPurchaseBill({ pageSize: 1000, filterBy: key, filterValue: '' });
			selectInputData = data?.purchaseBills?.reduce((acc, pb) => {
				if (key === 'vendor_name') {
					acc.push({
						key: pb.vendor?.vendor_name,
						value: pb.vendor?.vendor_name,
					});
					return acc;
				} else if (
					key === 'purchase_receive_number' &&
					pb?.purchase_receive?.purchase_receive_number
				) {
					acc.push({
						key: pb?.purchase_receive?.purchase_receive_number,
						value: pb?.purchase_receive?.purchase_receive_number,
					});
					return acc;
				} else {
					acc.push({
						key: pb[key],
						value: pb[key],
					});
					return acc;
				}
			}, []);
		} else {
			selectInputData = [
				{ key: 'Draft', value: 'Draft' },
				{ key: 'Open', value: 'Open' },
				{ key: 'Partially Paid', value: 'Partially Paid' },
				{ key: 'Paid/Closed', value: 'Paid/Closed' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'Draft', value: 'Draft' },
					{ key: 'Open', value: 'Open' },
					{ key: 'Partially Paid', value: 'Partially Paid' },
					{ key: 'Paid/Closed', value: 'Paid/Closed' },
				];
			} else {
				const { purchase_bills } = await fetchPurchaseBill({
					pageSize: 1000,
					filterBy: key,
					filterValue: value,
				});
				optionsList = purchase_bills?.map((pb) => ({
					key: key === 'vendor_name' ? pb?.vendor?.vendor_name : pb[key],
					value: key === 'vendor_name' ? pb?.vendor?.vendor_name : pb[key],
				}));
			}
			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;

			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };
			if (updatedParams.status === 'Draft') {
				updatedParams.status = 0;
			}

			if (updatedParams.status === 'Open') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Partially Paid') {
				updatedParams.status = 2;
			}

			if (updatedParams.status === 'Paid/Closed') {
				updatedParams.status = 3;
			}

			const { purchaseBills, totalPages } = await getPurchaseBills({
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: updatedParams,
			});
			const purchaseBillFilterData = purchaseBills
				? purchaseBills.map((pr) => {
						return {
							id: pr.purchase_bill_id,
							DATE: getDate(pr.bill_date),
							'PO#': pr?.purchase_order_number || 'N/A',
							'PR#': pr?.purchase_receive_number || 'N/A',
							'VENDOR NAME': pr?.vendor_name,
							AMOUNT: Number(pr?.bill_amount).toFixed(2),
							'BALANCE DUE': pr?.due_amount,
							STATUS: pr?.status,
							PB: JSON.stringify({
								pb_number: pr?.bill_number,
								status: pr?.status,
								AMOUNT: pr?.bill_amount,
							}),
						};
					})
				: [];
			dispatch(setAdvanceFilterTotalPage({ totalPages: totalPages }));
			setPurchaseBills((prev) => ({
				...prev,
				data: purchaseBillFilterData,
				totalPages: totalPages,
			}));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error('Something went wrong! Try again.');
		}
	}

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			handleFetchPurchaseBill();
		}
	}, [purchaseBillParams, advanceFilterPage, advanceFilterPageSize, isAdvanceFilterApplied]);

	return (
		<div style={{ overflow: 'auto' }}>
			{bulkAction && bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							button="Print"
							disabled={
								!hasPermission(
									'purchases.purchase_bills.download_print_pdf',
									user?.role?.role_permissions,
								)
							}
							className="mt-0 px-4 btn-gray"
							loader={loading.pdf.isLoading}
							onClick={() => handlePBPrintAndDownloadPdf('print')}
						/>

						<Button
							type="button"
							button="Record Bulk Payment"
							className="mt-0 px-4 ButtonColor"
						/>
						<Button
							type="button"
							button="Link to Purchase Order"
							className="mt-0 px-4 ButtonColor"
						/>
						<Button
							type="button"
							button=""
							className="mt-0 px-4 btn-danger"
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						className="dropdown text-end d-flex"
						style={{ gap: '12px', display: 'flex', alignItems: 'center' }}
					>
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: null, filterValue: null },
											'active',
											'All Purchase Bill',
										)
									}
								>
									All Purchase Bills
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 0 }, 'active', 'Draft')
									}
								>
									Draft
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 1 }, 'active', 'Open')
									}
								>
									Open
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: 'status', filterValue: 2 },
											'active',
											'Partially Paid',
										)
									}
								>
									Partially Paid
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 3 }, 'active', 'Paid/Closed')
									}
								>
									Paid/Closed
								</a>
							</li>
						</ul>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('All Purchase Bills');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<Button
									type="button"
									button="Advanced Filters"
									className="mt-0 px-4 btn-primary"
									onClick={() => setIsAdvanceFilterOpen(true)}
									icon={advanceFilterIcon}
								/>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-5"
							disabled={
								!hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
							}
							button="Create New Purchase Bill"
							add
							onClick={() => navigateRouter(`/user/${suburl}/purchases-bills-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={sortbydot} />
							</a>
							{/* date , reason, created_at , description,status,reference_number, */}
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a className="dropdown-item sortBy">Sort By</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'updated_at', sortBy: 'asc' })}
									>
										Last Modified time
										<span>{sortIconMap[sortDirection?.updated_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'bill_date', sortBy: 'asc' })}
									>
										Bill Date
										<span>{sortIconMap[sortDirection?.bill_date]}</span>
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'purchase_bill_id', sortBy: 'asc' })}
									>
										Bill #<span>{sortIconMap[sortDirection?.purchase_bill_id]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Vendor Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'due_date', sortBy: 'asc' })}
									>
										Due Date
										<span>{sortIconMap[sortDirection?.due_date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'bill_amount', sortBy: 'asc' })}
									>
										Bill Amount
										<span>{sortIconMap[sortDirection?.bill_amount]}</span>
									</a>
								</li>
								<li>
									<a
										className={`dropdown-item ${!hasPermission('purchases.purchase_bills.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
										onClick={() => exportData(`purchase_bill`)}
									>
										Export Purchase Bill
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('All Purchase Bills');
											setPurchaseBillParams({
												page: 1,
												pageSize: 20,
												orderBy: 'purchase_bill_id',
												sortBy: 'asc',
												filterBy: null,
												filterValue: null,
											});
										}}
									>
										Refresh
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									handleOnFocusSelectedFilterInput(item?.key);
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									if (item?.key === 'status') {
										setHeaderDropDown(option?.value);
									}
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Purchase Bills');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>

			{isDeleteBulkConfirmationModalOpen && (
				<DeletePurchaseBillModel
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteBulkConfirmationModalOpen}
					selectedVendorsListForDelete={selectedVendorsListForDelete}
					handleBulkDelete={handleBulkDelete}
					purchaseBillLength={bulkAction.length}
				/>
			)}

			{loader ? (
				<PageLoader />
			) : (
				<div className="productTable-body">
					<Table
						row={purchaseBill.data}
						coloum={PurchaseBillColoum}
						className="productTable"
						onRowClick={onRowClick}
						action={setBulkAction}
						bulkAction={bulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			)}
			<Pagination
				currentPage={isAdvanceFilterApplied ? advanceFilterPage : purchaseBillParams.page}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : purchaseBill?.totalPages}
				onChangePage={handlePageChange}
				pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : purchaseBillParams.pageSize}
				setParam={(value) => {
					if (isAdvanceFilterApplied) {
						dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
					} else {
						setPurchaseBillParams((prev) => ({
							...prev,
							pageSize: value,
							page: 1,
						}));
					}
				}}
			/>

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.purchase_bill}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default PurchaseBills;
